import { CryptoInputSwitcher as UICryptoInputSwitcher, type CryptoInputSwitcherProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type Props = Omit<CryptoInputSwitcherProps, 'switcherLabel'> & {
  switchTo?: string;
}

const CryptoInputSwitcher = ({ switchTo = 'JIDR', ...rest }: Props) => {
  const { t } = useTranslation();
  return (
    <UICryptoInputSwitcher
      {...rest}
      switcherLabel={t('topUpCrypto.preview.switcher', { switchTo })}
    />
  );
}

export default CryptoInputSwitcher;
